import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AnalyticsLayout } from '@/components/analytics';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/analytics')({
  component: AnalyticsLayoutRoute,
});

function AnalyticsLayoutRoute() {
  return (
    <AnalyticsLayout>
      <Outlet />
    </AnalyticsLayout>
  );
}
